export const protocol_questions = {
  edit: {
    history: {
      title: "Histórico de alterações do protocolo",
      changed_by: "Alterado por",
      changed_at: "Alterado em",
    },
    viewing_local_changes: "Você está visualizando alterações locais.",
    viewing_live_version: "Você está visualizando a versão ao vivo.",
    clear_local_changes: "Limpar alterações locais",
    other_protocol_questions_linked_to_the_requirement: "Outras questões de protocolo vinculadas a este requisito",
    no_other_protocol_questions_linked_to_the_requirement:
      "Nenhuma outra questão de protocolo está vinculada a este requisito",
    interlink_questions: "Interligar questões",
    save_links: "Salvar links",
  },
  back_to_protocol_question_edit: "Voltar para edição de questão de protocolo",
  link: {
    protocol_questions: {
      disabled_link_reason: "Você precisa selecionar pelo menos uma questão de protocolo para vincular.",
      page_title: "Vincular Questões de Protocolo Relacionadas",
      page_description:
        "Conecte Questões de Protocolo relacionadas para permitir o compartilhamento de dados entre elas durante as avaliações. Questões vinculadas permitem que você copie respostas de uma questão para outra.",
      linked_items_title: "Esta questão de protocolo já está vinculada a:",
    },
    requirements: {
      page_title: "Aqui você pode selecionar e vincular requisitos a esta questão de protocolo.",
      page_description: "Vincular requisitos à Questão de Protocolo",
    },
  },
} as const;
